import posthog from "posthog-js";

export function track(eventOrName, properties) {
  if (typeof eventOrName === "string") {
    posthog.capture(eventOrName, properties);
  } else {
    posthog.capture(eventOrName.event_type, eventOrName.event_properties);
  }
}

export function identifyUser(userId, properties) {
  posthog.identify(userId, properties);
}

export function registerSuperProperties(properties) {
  posthog.register(properties);
}

export function resetAnalytics() {
  posthog.reset();
}
